'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountry = getCountry;

var _noAuthApiClient = require('../utils/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ENDPOINT = '/acquisition/v1/iplocation';

function getCountry() {
  return _noAuthApiClient2.default.get(API_ENDPOINT + '/country');
}